import React, { useEffect, useState } from "react";
import { Role } from "@/model";
import { useRole } from "@/query/role";
import { useAgentId } from "@/hook";
import { DropdownGroup, DropdownButton, DropdownItem, DropdownItems } from "@/component/input";


interface RoleDropDownProps {
    role?: Role;
    onChange: (role: Role) => void;
}

const RoleDropDown: React.FC<RoleDropDownProps> = (props) => {
    const { role, onChange } = props;

    const agentId = useAgentId();

    const [selectedRole, setSelectedRole] = useState<Role | undefined>(role);

    const { data: roles, isLoading } = useRole(agentId);

    const handleSelectRole = (role: Role) => {
        setSelectedRole(role);
        onChange(role);
    };

    useEffect(() => {
        if (role) {
            setSelectedRole(role);
        } else if (roles?.length) {
            setSelectedRole(roles[0]);
            onChange(roles[0]);
        }
    }, [role, roles, onChange]);

    if (isLoading) {
        return <div>Loading roles....</div>;
    }
    return (
            <DropdownGroup>
                <DropdownButton>
                    {selectedRole?.description}
                </DropdownButton>
                <DropdownItems>
                    {roles?.map((role, index) => (
                        <DropdownItem key={role.id}
                                      isOdd={index % 2 === 1}
                                      onClick={() => handleSelectRole(role)}
                        >
                            {role.description}
                        </DropdownItem>
                    ))}
                </DropdownItems>
            </DropdownGroup>
    );
};

export default RoleDropDown;